import { render } from "./WaveBackground.vue?vue&type=template&id=06cdd5ed&scoped=true"
import script from "./WaveBackground.vue?vue&type=script&lang=js"
export * from "./WaveBackground.vue?vue&type=script&lang=js"

import "./WaveBackground.vue?vue&type=style&index=0&id=06cdd5ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cdd5ed"]])

export default __exports__